import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { 
  faBlind, 
  faDeaf, 
  faWalking, 
  faWheelchair
} from '@fortawesome/free-solid-svg-icons';


import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { typeProfil } from 'handimap-react-lib/enum/typeProfil';
import SvgS3AIcon from 'handimap-react-lib/components/icons/mentIcon';
import { IconMenuItems } from 'handimap-react-lib/components/Select/CustomMenuItem';
import { IconItemsList } from 'handimap-react-lib/components/Select/CustomListItem';
import theme from '../theme';


export const TypeSelectItem = props => {
  const {t} = useTranslation();
  
  const renderIcon = () => {
    switch (props['data-value']) {
      case typeProfil.TYPE_1:
        return <FontAwesomeSvgIcon icon={faWalking} ariaHidden={null} ariaLabel={t('form.profile-walk')}/>; 
      case typeProfil.TYPE_2:
        return <FontAwesomeSvgIcon icon={faBlind} ariaHidden={null} ariaLabel={t('form.profile-visual')}/>; 
      case typeProfil.TYPE_3:
        return <FontAwesomeSvgIcon icon={faWheelchair} ariaHidden={null} ariaLabel={t('form.profile-wheelchair')}/>; 
      case typeProfil.TYPE_4:
        return <FontAwesomeSvgIcon icon={faDeaf} ariaHidden={null} ariaLabel={t('form.profile-hearing')}/>; 
      case typeProfil.TYPE_5:
        return <SvgS3AIcon color={theme.palette.primary.main} aria-hidden={null} aria-label={t('form.profile-mental')}/>; 
      default:
        return <React.Fragment />;
    }
  };
  let {selected, label} = props;

  const styles = {
    tooltip: {
      fontSize: '1.1em'
    }
  };

  return (
    <Tooltip 
      title={
        <p style = {styles.tooltip}>{label}</p>
      } 
      placement='bottom'
      arrow>
      <IconMenuItems active={selected ? 'true' : 'false'} {...props}>
        <IconItemsList active={selected ? 'true' : 'false'}>
          {renderIcon()}
        </IconItemsList>
      </IconMenuItems>
    </Tooltip>
  );
};